import { Checkbox, CheckboxProps } from '@almbrand/checkbox';
import { useEffect } from 'react';
import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { store } from 'store/store';
export interface CheckboxComponentProps extends CheckboxProps {
	register: UseFormRegister<FieldValues>;
	contentType: string;
	stepContentId: string;
	submitStep?: () => void;
	stepTitle?: string;
	setValue: UseFormSetValue<FieldValues>;
}
export const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
	register,
	submitStep,
	contentType,
	stepContentId,
	setValue,
	...props
}) => {
	const { onChange, name } = register(stepContentId.toString());
	const handleChange = (e) => {
		onChange({
			target: {
				name,
				value: {
					id: name,
					value: e.target.checked,
					type: contentType,
					stepTitle: props.stepTitle,
				},
			},
		});
		submitStep?.();
	};

	useEffect(() => {
		const value = store.getState().calculatorForm[name]?.data?.value;
		setValue(name, {
			id: name,
			value,
			type: contentType,
			stepTitle: props.stepTitle,
		});
	}, []);

	return (
		<Checkbox
			{...props}
			onChange={handleChange}
		/>
	);
};
